import styles from "./Button.module.css";

export default function Button({
  children,
  variant = "default",
  iconOnly = false,
  icon = null,
  iconPosition = "right",
  className = "",
  ...props
}) {
  const classes = [
    styles.button,
    styles[variant],
    iconOnly ? styles.iconOnly : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={classes} type="button" {...props}>
      {icon && iconPosition === "left" && !iconOnly ? (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      ) : null}
      {!iconOnly ? <span className={styles.label}>{children}</span> : null}
      {(iconOnly || (icon && iconPosition === "right")) ? (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      ) : null}
    </button>
  );
}
